import React, { useState, useEffect } from 'react'
import { Form, Spinner } from 'react-bootstrap'
import { Button, Card, CardBody } from 'reactstrap'
import moment from 'moment'

import { storesRegionsSettings } from '../../Settings/services'
import { handleError } from '../../../helpers'
import { Divider } from 'antd'

export default function MomentosGeneralForm({ report, params, setParams, onSubmit, loading }) {
	const [storesRegions, setStoresRegions] = useState(null)

	useEffect(() => {
		!storesRegions && storesRegionsSettings()
			.then(res => setStoresRegions(res.data.data))
			.catch(error => handleError(error))
	}, [ storesRegions ])

	const handlePreviousMonth = () => {
		const from = moment(params.from).subtract(1, 'month').format('YYYY-MM-DD')
		const until = moment(from).endOf('month').format('YYYY-MM-DD')
		setParams({ ...params, from, until })
	}

	const handleNextMonth = () => {
		const from = moment(params.from).add(1, 'month').format('YYYY-MM-DD')
		const until = moment(from).endOf('month').format('YYYY-MM-DD')
		setParams({ ...params, from, until })
	}

	return (
		<React.Fragment>
			<Card>
				<CardBody>
					<p className='bold mb-0'>Facturas que cumple con:</p>
					<p className='mb-0 small'>1. No son de cajas I00, I05, I10, A20, Z65</p>
					<p className='mb-0 small'>2. Son de miembros activos contactables</p>
					<p className='mb-10 small'>3. No son de cédulas de empleados ni tienen tarifa 2040</p>
					<p className='bold mb-0'>Facturas con fecha entre:</p>
					<Form.Control 
						type="date"
						value={params.from}
						onChange={e => setParams({...params, from: e.target.value})}
					/>
					<p className='bold mb-0 mt-10'>Hasta el dia:</p>
					<Form.Control 
						type="date"
						value={params.until}
						onChange={e => setParams({...params, until: e.target.value})}
					/>
					<div>
						<span className="text-link" onClick={handlePreviousMonth}>Mes Anterior</span>
						<Divider type="vertical" />
						<span className="text-link" onClick={handleNextMonth}>Siguiente Mes</span>
					</div>
					<p className='bold mb-0 mt-10'>Para las regionales:</p>
					<Form.Control
						as="select"
						value={params.region}
						onChange={e => setParams({ ...params, region: e.target.value })}
					>
						<option value="">:: Todas las regionales ::</option>
						{ storesRegions ? (
							<React.Fragment>
								{ storesRegions.map(r => (
									<option key={r.region} value={r.region}>{r.region}</option>
								))}
							</React.Fragment>
						) : <option value="loading" disabled>Cargando...</option> }
					</Form.Control>
					{ (params.type !== 'organico') && (
						<>
							{ (params.type !== 'gestion_email_marketing') && (
								<>
									<p className='bold mb-0 mt-10'>Gestión Email Marketing:</p>
									<Form.Control
										as="select"
										value={params.exclude_email_marketing}
										onChange={e => setParams({ ...params, exclude_email_marketing: e.target.value })}
									>
										<option value="1">Excluir</option>
										<option value="0">Incluir</option>
									</Form.Control>
								</>
							)}
							{ (params.type !== 'gestion_tiendas') && (
								<>
									<p className='bold mb-0 mt-10'>Gestión Tiendas:</p>
									<Form.Control
										as="select"
										value={params.exclude_spring_resell}
										onChange={e => setParams({ ...params, exclude_spring_resell: e.target.value })}
										>
										<option value="1">Excluir</option>
										<option value="0">Incluir</option>
									</Form.Control>
								</>
							)}
							{(params.type !== 'gestion_cumpleanos') && (
								<>
									<p className='bold mb-0 mt-10'>Gestión Cumpleaños:</p>
									<Form.Control
										as="select"
										value={params.exclude_birthdays}
										onChange={e => setParams({ ...params, exclude_birthdays: e.target.value })}
										>
										<option value="1">Excluir</option>
										<option value="0">Incluir</option>
									</Form.Control>
								</>
							)}
							{ (params.type !== 'gestion_sms_marketing') && (
								<>
									<p className='bold mb-0 mt-10'>Gestión SMS Marketing:</p>
									<Form.Control
										as="select"
										value={params.exclude_sms_marketing}
										onChange={e => setParams({ ...params, exclude_sms_marketing: e.target.value })}
									>
										<option value="1">Excluir</option>
										<option value="0">Incluir</option>
									</Form.Control>
								</>
							)}
						</>
					)}
					<Button 
						color='primary' 
						className='mt-15' 
						onClick={onSubmit}
						disabled={loading}
					>
						Generar Reporte{" "}
						{ loading && <Spinner animation='border' size="sm" /> }
					</Button>
				</CardBody>
			</Card>
			{ report && (
				<Card>
					<CardBody>
						<p>Visualizando el reporte con facturas desde el <b>{report.params.from}</b> hasta <b>{report.params.until}</b> para <strong>{report.params.region ? report.params.region : 'todas las regionales'}</strong></p>
						<p><b>Consultado el: </b>{report.data.consult_at}</p>
					</CardBody>
				</Card>
			)}
		</React.Fragment>
	)
}